module.exports = __webpack_public_path__ + "img/Terraform-6-mobile.9499618a.png";